import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import './index.less';

const Description = ({ term, children, col, ...rest }) => {
  return (
    <Col className="description" {...rest} span={col}>
      {term && <div className="term">{term}</div>}
      {children && <div className="detail">{children}</div>}
    </Col>
  );
};

Description.defaultProps = {
  term: '',
};

Description.propTypes = {
  term: PropTypes.node,
};

const DescriptionList = ({
  title,
  col = 3,
  gutter = 32,
  layout = 'horizontal',
  children,
  ...rest,
}) => {
  return (
    <div className="description-list">
      {title && <div className="title">{title}</div>}
      <Row gutter={gutter}>
        {React.Children.map(children, child => child ? React.cloneElement(child, { col }) : child)}
      </Row>
    </div>
  );
};

DescriptionList.Description = Description;

export default DescriptionList;


// WEBPACK FOOTER //
// ./src/components/DescriptionList/index.js